// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as Sentry from '@sentry/react';
import { getCurrentUser } from '@/authentication/api/get-current-user';
import { AppShell } from '@/components/app-shell';
import { ErrorPage } from '@/components/error-page';
import { useMaintenanceCheck } from '@/hooks/use-maintenance-check';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({
  component: AppRoute,
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData({
        queryKey: ['current-user'],
        queryFn: async () => {
          const { user } = await getCurrentUser();

          Sentry.setUser({ id: user.id, email: user.email });

          return user;
        },
      });
    } catch (_) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  onError: (error) => Sentry.captureException(error),
  errorComponent: () => (
    <AppShell>
      <ErrorPage />
    </AppShell>
  ),
});

function AppRoute() {
  useMaintenanceCheck();

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
